import React from 'react'
import Tooltip from '@components/tooltip'
export default function Drawer({children, isVisible, hide}) {
  React.useEffect(() => {
    if (isVisible) {
      document.body.style.top = `-${window.scrollY}px`
      document.body.style.position = 'fixed'
    } else {
      const scrollY = document.body.style.top
      document.body.style.position = ''
      document.body.style.top = ''
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }, [isVisible])

  return (
    <div className={`drawer-backdrop ${isVisible ? 'show' : ''}`} onClick={hide}>
      <div
        onClick={e => e.stopPropagation()}
        className={`drawer left ${isVisible ? 'is-visible-left' : ''}`}
        style={{width: 250}}
      >
        <div style={{display: 'flex', alignItems: 'center', padding: '8px', justifyContent: 'space-between'}}>
          <span>
            <b>Menu</b>
          </span>
          <Tooltip
            key="get-support-tooltip"
            placement="bottom"
            trigger={props => (
              <div {...props} className="button is-white" onClick={hide}>
                <span className="icon">
                  <i className="fa-light fa-times" />
                </span>
              </div>
            )}
          >
            <p className="help">Menu</p>
          </Tooltip>
        </div>
        {children}
      </div>
    </div>
  )
}
